import {DceComponent, DceHTMLElement} from "dce-engine";
import {DceAjax, DceAjaxAction} from "dce-ajax";
import Dce from "dce-engine/lib/decorators/Dce";
import {Md5} from "ts-md5";
import {createDomElementFromString} from "app/lib/utils/createDomElementFromString";
import {Modal, OpenModal} from "app/lib/index";

interface OrderPageProps {

}

@Dce("OrderPage")
export default class OrderPage extends DceComponent<OrderPageProps>{

    constructor(elem: DceHTMLElement, props: OrderPageProps) {
        super(elem, props);


    }

    public submitData(): void {
        this.elem.querySelector('form').dispatchEvent(
            new SubmitEvent("submit")
        );
    }

}